module.exports = __webpack_public_path__ + "static/images/coupon-no-icon.9dbe472.png";